<template>
    <b-card :title="title">
        <b-card-header >   
            <b-row>
                <b-col class="col-md-8">
                    <b-input v-model="filter" type="search" placeholder="Search Activity templates..."></b-input>
                </b-col>

                <b-col >
                    <slot></slot>
                </b-col>
            </b-row>
        </b-card-header>


        <b-card-body>
            
            <p class="mt-3">
                Page: {{ currentPage }} of {{ Math.ceil(rows/itemsPerPage) }} Total:
                {{  rows}}
            </p>

            <b-table
                :fields="fields"
                striped
                hover
                responsive
                :items="templates"
                :per-page="itemsPerPage"
                :current-page="currentPage"
                :filter="filter"
            >
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        v-if="hasPermissionView"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>

        <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="itemsPerPage"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>


    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'OrderTemplates-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'title', 'items'],

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
            fields: [
                {
                    key: 'id',
                    label: 'Actions',
                },
                'name',

                {
                    key: 'order_category_id',
                    label: 'Category',
                    formatter: (value, key, item) => item.category.name,
                },
                {
                    key: 'order_type_id',
                    label: 'Type',
                    formatter: (value, key, item) => item.type.name,
                },
            ],
        }
    },

    mounted() {},

    methods: {},

    computed: {
        templates() {
            const templates = this.$store.state.orderTemplate.templates
            console.log('templates', templates)
            return templates
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.templates.length
        }
        
    },
}
</script>
<style></style>
